<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('turkmer_page_title')"
                        :isFilter="false"
                >
                </Header>
            </template>
            <template v-slot:header-mobile>
                <header-mobile :title="$t('turkmer_page_title')"
                               :isFilter="false">
                </header-mobile>
            </template>
            <b-tabs content-class="pt-5 position-relative" class="line-tabs" v-model="tabIndex">
                <ValidationObserver ref="program_selectForm">
                    <b-tab :title="$t('program_select')" active ref="tab1">
                        <b-row class="border p-3">
                            <b-col cols="12">
                                <b-row>
                                    <b-col md="6" lg="6">
                                        <ValidationProvider name="program_type" rules="required" v-slot="{valid, errors}">
                                            <b-form-group :label="$t('application_type')">
                                                <parameter-selectbox :validate-error="errors[0]"
                                                                     v-model="formData.program_type"
                                                                     code="turkmer_application_types"/>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col md="6" lg="6">
                                        <ValidationProvider name="program_code" rules="required"
                                                            v-slot="{valid, errors}">
                                            <b-form-group :label="$t('program')">
                                                <multiselect :placeholder="$t('select')"
                                                             v-model="formData.program_code"
                                                             :options="filteredProgramCodeOptions" :select-label="''"
                                                             label="text"
                                                             track-by="value"
                                                             :selected-label="''" :deselect-label="''"
                                                             :searchable="false"
                                                             :class="errors[0] ? 'is-invalid' : (valid ? 'is-valid' : null)"
                                                >
                                                </multiselect>
                                            </b-form-group>
                                            <div class="invalid-feedback d-block" v-if="errors[0]"
                                                 v-html="errors[0]"></div>

                                        </ValidationProvider>
                                    </b-col>
                                    <b-col md="6" lg="6">
                                        <ValidationProvider
                                            name="before_turkish_certificate_status"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-group :label="certificateLabel" class="m-0">
                                                <b-form-radio-group
                                                    v-model="formData.before_turkish_certificate_status"
                                                    :options="options"
                                                    :class="errors[0] ? 'is-invalid' : null"
                                                ></b-form-radio-group>
                                            </b-form-group>

                                            <div class="invalid-feedback d-block" v-if="errors[0]">
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                        <div v-if="formData.before_turkish_certificate_status===1" class="mt-3">
                                            <ValidationProvider name="before_turkish_certificate"
                                                                :rules="formData.before_turkish_certificate_status===1?'required':''"
                                                                v-slot="{errors}">
                                                <b-form-group :label="$t('certificate_upload')">
                                                    <div class="d-flex custom-file-upload">
                                                        <b-form-file
                                                            v-model="formData.before_turkish_certificate"
                                                            :state="errors[0] ? false : null"
                                                            :placeholder="$t('select_file')"
                                                            :drop-placeholder="$t('drop_file')"
                                                            ref="fileInput"
                                                        ></b-form-file>
                                                        <b-button variant="outline-secondary"
                                                                  @click="$refs.fileInput.$el.childNodes[0].click();">
                                                            {{ $t('browse') }}
                                                        </b-button>
                                                    </div>
                                                    <div class="alert alert-warning mt-3">
                                                        {{ $t('only_pdf_files_can_be_uploaded') }}
                                                    </div>
                                                    <div class="invalid-feedback d-block" v-if="errors[0]"
                                                         v-html="errors[0]"></div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-tab>
                </ValidationObserver>
                <ValidationObserver ref="personal_infoForm">
                    <b-tab :title="$t('personal_info')" ref="tab2">
                        <b-row class="border p-3">
                            <b-col md="6" lg="4">
                                <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('name')">
                                        <b-form-input
                                            v-model="formData.name"
                                        ></b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="surname" rules="required"
                                                    v-slot="{valid, errors}">
                                    <b-form-group :label="$t('surname')">
                                        <b-form-input
                                            v-model="formData.surname"
                                        ></b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4" v-show="identity_type === 'passport'">
                                <ValidationProvider name="passport_number"
                                                    :rules="identity_type === 'passport' ? 'required' : ''"
                                                    v-slot="{valid, errors}">
                                    <b-form-group :label="$t('passport_number')">
                                        <b-form-input type="text" size="sm"
                                                      v-model="formData.passport_number"
                                        ></b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4" v-show="identity_type === 'tc'">
                                <ValidationProvider name="national_id"
                                                    :rules="identity_type === 'tc' ? 'required' : ''"
                                                    v-slot="{valid, errors}">
                                    <b-form-group :label="$t('tc_no')">
                                        <b-form-input type="text" size="sm" v-model="formData.national_id"
                                                      v-check-min-max-value></b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="nationality" rules="required"
                                                    v-slot="{valid, errors}">

                                    <b-form-group :label="$t('nationality')">
                                        <country-selectbox valueType="code"
                                                           v-model="formData.nationality_code"
                                                           :placeholder="$t('nationality')"
                                                           :state="errors[0] ? false:null"
                                                           :validate-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <b-form-group :label="$t('father_name')">
                                    <ValidationProvider name="father_name" rules="required" v-slot="{ errors }">
                                        <b-form-input v-model="formData.father_name"
                                                        :state="errors[0] ? false : null"/>
                                        <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" lg="4">
                                <b-form-group :label="$t('mother_name')">
                                    <ValidationProvider name="mother_name" rules="required" v-slot="{ errors }">
                                        <b-form-input v-model="formData.mother_name"
                                                        :state="errors[0] ? false : null"/>
                                        <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="gender" rules="required"
                                                    v-slot="{valid, errors}">
                                    <b-form-group :label="$t('gender')">
                                        <gender-selectbox v-model="formData.gender"
                                                          :validate-error="errors[0]">
                                        </gender-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="birthdate" rules="required"
                                                    v-slot="{valid, errors}">
                                    <b-form-group :label="$t('date_of_birth')" class="position-relative">
                                        <v-date-picker
                                            v-model="formData.birthdate"
                                            :locale="$i18n.locale"
                                            is-expanded
                                            :popover="{ 'visibility': 'click' }">

                                            <template
                                                v-slot="{ inputValue, inputEvents }">
                                                <b-input-group>
                                                    <b-form-input
                                                        :readonly="true"
                                                        :value="inputValue"
                                                        v-on="inputEvents"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button
                                                            variant="outline-secondary"
                                                            class="btn-40"
                                                            disabled
                                                        >
                                                            <i class="ri-calendar-line"></i
                                                            ></b-button>
                                                    </b-input-group-append>
                                                    <b-form-invalid-feedback v-if="errors[0]"
                                                                             v-html="errors[0]"></b-form-invalid-feedback>

                                                </b-input-group>
                                            </template>
                                        </v-date-picker>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="mobile_tel"
                                                    maxlength="11"
                                                    rules="required"
                                                    v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('gsm_no')">
                                        <b-form-input v-model="formData.mobile_tel"
                                                      :placeholder="$t('gsm_no')"
                                                      v-mask="'5##-###-####'"
                                                      :state="errors[0] ? false : null"/>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="email" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('email')">
                                        <b-form-input type="text"
                                                      v-model="formData.email"
                                                      :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                                                 v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="city_id" rules="required"
                                                    v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('city')">
                                        <city-selectbox v-model="formData.city_id"></city-selectbox>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                                                 v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="district_id" rules="required" v-slot="{ errors }">
                                    <b-form-group :label="$t('district')">
                                        <district-outline-selectbox v-model="formData.district_id"
                                                                    :city_id="formData.city_id"
                                                                    :validateError="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="address"
                                                    rules="required"
                                                    v-slot="{ valid, errors }"
                                >
                                    <b-form-group :label="$t('address')">
                                        <b-form-textarea
                                            v-model="formData.address"
                                        ></b-form-textarea>
                                    </b-form-group>
                                    <b-form-invalid-feedback
                                        v-if="errors[0]"
                                        v-html="errors[0]"
                                        class="mb-2"
                                    ></b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="emergency_person" rules="required"
                                                    v-slot="{valid, errors}">
                                    <b-form-group :label="$t('emergency_person')">
                                        <b-form-input type="text"
                                                      v-model="formData.emergency_person"
                                                      :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                                                 v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" lg="4">
                                <ValidationProvider name="emergency_person_number"
                                                    maxlength="11"
                                                    rules="required"
                                                    v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('emergency_person_phone')">
                                        <b-form-input v-model="formData.emergency_person_number"
                                                      :placeholder="$t('gsm_no')"
                                                      v-mask="'5##-###-####'"
                                                      :state="errors[0] ? false : null"/>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-tab>
                </ValidationObserver>
                <ValidationObserver ref="documentsForm" v-if="formData.status != 'waiting_preference'">
                    <b-tab :title="$t('documents')" ref="tab3">
                        <b-row class="border p-3">
                            <b-col cols="12">
                                <h6>{{ $t('documents') }}</h6>
                            </b-col>
                            <b-col cols="12">
                                <div class="d-flex flex-wrap">
                                    <b-card
                                        :sub-title="getLocaleText(doc,'name')"
                                        class="mr-2" style="min-width: 18rem;"
                                        v-for="(doc, index) in formData.documents" :key="index">
                                        <b-card-text>{{ $t('status') }}: {{ $t(`status_${doc.status}`) }}</b-card-text>
                                        <template v-if="checkPermission('turkmer_application_admin_document_upload') && formData.status === 'in_evaluation'">
                                            <input
                                                type="file"
                                                :ref="`adminFileInput_${index}`"
                                                style="display:none"
                                                @change="adminUploadDoc($event, index)"
                                            />
                                            <b-button size="sm" variant="outline-primary" class="mt-2 w-100"
                                                      @click="$refs[`adminFileInput_${index}`][0].click()">
                                                {{ $t('upload') }}
                                            </b-button>
                                        </template>
                                        <template #footer>
                                            <div class="d-flex flex-row justify-content-around">
                                                <a class="card-link"
                                                   @click="showDoc(doc,index)">{{ $t('download') }}</a>
                                                <b-link v-if="doc.status !== 'accepted'"
                                                        class="card-link text-success"
                                                        @click="approveDoc(doc, index, 'accepted')">
                                                    {{ $t('approve') }}
                                                </b-link>
                                                <b-link v-if="doc.status !== 'denied'"
                                                        class="card-link text-danger ml-3"
                                                        @click="approveDoc(doc, index, 'denied')">
                                                    {{ $t('reject') }}
                                                </b-link>
                                            </div>
                                        </template>
                                    </b-card>
                                </div>
                            </b-col>
                            <b-col v-if="originalStatus === 'pending_current_services' && checkPermission('turkmerapplication_workcertificateapprove')" cols="12" class="mt-4">
                                <ValidationObserver ref="workCertForm">
                                    <h6>{{ $t('work_certificate_approval') }}</h6>
                                    <b-row>
                                        <b-col md="4">
                                            <ValidationProvider name="workCertStatus" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('status')">
                                                    <b-form-select
                                                        v-model="workCertForm.status"
                                                        :options="workCertStatusOptions"
                                                        :state="errors[0] ? false : null"
                                                    />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <template v-if="workCertForm.status === 'accepted'">
                                            <b-col md="4">
                                                <ValidationProvider name="scholarshipTypeCode" rules="required" v-slot="{ errors }">
                                                    <b-form-group :label="$t('scholarship_type')">
                                                        <scholarship-types-selectbox
                                                            v-model="workCertForm.scholarship_type_code"
                                                            value-field="code"
                                                            :validate-error="errors[0]"
                                                        />
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col md="4">
                                                <ValidationProvider name="discountRate" rules="required|numeric" v-slot="{ errors }">
                                                    <b-form-group :label="$t('discount_rate')">
                                                        <b-form-input
                                                            v-model="workCertForm.discount_rate"
                                                            type="number"
                                                            :state="errors[0] ? false : null"
                                                        />
                                                        <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"/>
                                                    </b-form-group>
                                                </ValidationProvider>  
                                            </b-col>
                                        </template>
                                        <b-col v-if="workCertForm.status === 'denied'" md="8">
                                            <ValidationProvider name="workCertReason" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('reject_why')">
                                                    <b-form-textarea
                                                        v-model="workCertForm.reason"
                                                        rows="3"
                                                        :state="errors[0] ? false : null"
                                                    />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>

                                    </b-row>
                                </ValidationObserver>
                            </b-col>
                            <b-col cols="12" class="mt-2">
                                <ValidationProvider name="status" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('approval_status')">
                                        <parameter-selectbox v-model="formData.status"
                                                             :disabled="originalStatus === 'pending_current_services'"
                                                             :code="'turkmer_application_status'"
                                                             :validate-error="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                                <ValidationProvider name="rejectMessage"
                                                    :rules="formData.status == 'denied' ? 'required':''"
                                                    v-slot="{errors}">
                                    <b-form-group :label="$t('reject_why')"
                                                  v-if="formData.status == 'denied'">
                                        <b-form-textarea
                                            id="textarea"
                                            v-model="formData.reason"
                                            :placeholder="$t('')"
                                            rows="3"
                                            max-rows="6"
                                        ></b-form-textarea>
                                        <div class="invalid-feedback d-block" v-if="errors[0]"
                                             v-html="errors[0]"></div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6">
                                <b-button variant="primary" @click="handleSubmit">
                                    {{ $t('send_application').toUpper() }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-tab>
                </ValidationObserver>
                <ValidationObserver ref="documentsUploadForm" v-else>
                    <b-tab :title="$t('documents')" ref="tab3">
                        <b-row class="border p-3">
                            <b-col cols="12">
                                <h6>{{ $t('documents') }}</h6>
                            </b-col>
                            <b-col cols="12">
                                <ValidationProvider name="image" rules="required" v-slot="{errors}">
                                    <b-form-group :label="$t('please_upload_image')">
                                        <div class="d-flex custom-file-upload">
                                            <b-form-file
                                                v-model="fileData.image"
                                                :state="errors[0] ? false : null"
                                                :placeholder="$t('select_file')"
                                                :drop-placeholder="$t('drop_file')"
                                                ref="fileInput1"
                                            ></b-form-file>
                                            <b-button variant="outline-secondary"
                                                      @click="$refs.fileInput1.$el.childNodes[0].click();">
                                                {{ $t('browse') }}
                                            </b-button>
                                        </div>
                                        <div class="alert alert-warning mt-3 mb-0">
                                            {{ $t('only_png_files_can_be_uploaded') }}
                                        </div>
                                        <div class="invalid-feedback d-block" v-if="errors[0]"
                                             v-html="errors[0]"></div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12">
                                <ValidationProvider name="identity_front" rules="required" v-slot="{errors}">
                                    <b-form-group :label="$t('please_upload_identity')">
                                        <div class="d-flex custom-file-upload">
                                            <b-form-file
                                                v-model="fileData.identity_front"
                                                accept=".jpg,.jpeg,.png"
                                                :state="errors[0] ? false : null"
                                                :placeholder="$t('select_file')"
                                                :drop-placeholder="$t('drop_file')"
                                                ref="fileInput2"
                                            ></b-form-file>
                                            <b-button variant="outline-secondary"
                                                      @click="$refs.fileInput2.$el.childNodes[0].click();">
                                                {{ $t('browse') }}
                                            </b-button>
                                        </div>
                                        <div class="alert alert-warning mt-3 mb-0">
                                            {{ $t('only_png_files_can_be_uploaded') }}
                                        </div>
                                        <div class="invalid-feedback d-block" v-if="errors[0]"
                                             v-html="errors[0]"></div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6">
                                <b-button variant="primary" @click="uploadFiles">
                                    {{ $t('save').toUpper() }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-tab>
                </ValidationObserver>
                <div class="d-flex justify-content-end">
                    <!--                    <b-button v-if="tabIndex > 0" variant="secondary" class="mr-3" @click="back">
                                            {{ $t('back') }}
                                        </b-button>-->
                    <b-button
                        v-if="tabIndex < 2"
                        class="mt-2"
                        variant="primary"
                        @click="next"
                    >
                        {{ $t('next') }}
                    </b-button>
                </div>
            </b-tabs>
        </app-layout>
    </div>
</template>
<script>
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
import CitySelectbox from "@/components/interactive-fields/CitySelectbox.vue";
import MultiText from "@/components/interactive-fields/MultiText.vue";
import TurkmerApplicationProgramSelectBox from "@/components/interactive-fields/TurkmerApplicationProgramSelectBox.vue";
import ScholarshipTypesSelectbox from "@/components/interactive-fields/ScholarshipTypesSelectbox.vue";
import TurkmerApplicationService from "../../../services/TurkmerApplicationService";
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox.vue";
import moment from "moment";
import qs from "qs";
import programService from "@/services/ProgramService";

export default {
    components: {
        DistrictOutlineSelectbox,
        TurkmerApplicationProgramSelectBox,
        MultiText,
        ParameterSelectbox,
        CitySelectbox,
        ScholarshipTypesSelectbox,
    },
    data() {
        return {
            programs: [],
            workCertForm: {
                status: null,
                scholarship_type_code: null,
                discount_rate: null,
                reason: null,
            },
            courseCodeOptions: [
                {text: this.$t('course_code_option'), value: 'Course'},
                {text: this.$t('examinations'), value: 'Exam'},
            ],
            tabIndex: 0,
            masks: {
                input: "DD-MM-YYYY",
            },
            formData: {
                national_id: null,
                approval_status: null,
                name: null,
                surname: null,
                image: null,
                gender: null,
                birthdate: null,
                nationality_code: null,
                mobile_tel: null,
                email: null,
                emergency_person: null,
                emergency_person_phone: null,
                address: null,
                program: null,
                code: null,
                selected: null,
                program_type: null,
                program_code: null,
                district_id: null,
                documents: null,
            },
            queryParams: {
                filter: {
                    faculty_code: '50'
                },
            },
            options: [
                {text: 'Yes', value: 1},
                {text: 'No', value: 0},
            ],
            identity_type: null,
            fileData: {},
            originalStatus: null
        }
    },
    async created() {
        await this.getPrograms();
        this.getData(this.$route.params.id)
    },
    watch: {
        tabIndex(newValue) {
            if (newValue > 3) {
                this.tabIndex = 3;
            } else if (newValue < 0) {
                this.tabIndex = 0;
            }
        },
        'formData.program_type': function(newVal, oldVal) {
            if (oldVal && newVal !== oldVal) {
                this.formData.program_code = null;
            }
        }
    },
    methods: {
        redirectTab() {
            let tab1 = this.$refs.tab1.$el.querySelector('.is-invalid,.box-border-color')
            let tab2 = this.$refs.tab2.$el.querySelector('.is-invalid,.box-border-color')
            let tab3 = this.$refs.tab3.$el.querySelector('.is-invalid,.box-border-color')

            if (tab1) return this.tabIndex = 0;
            if (tab2) return this.tabIndex = 1;
            if (tab3) return this.tabIndex = 2;
        },
        getData(id) {
            TurkmerApplicationService.show(id)
                .then(response => {
                    this.formData = response.data.data
                    this.originalStatus = this.formData.status
                    this.formData.program_code = this.filteredProgramCodeOptions.find(option => option.value === this.formData.program_code);
                    this.identity_type = this.formData.passport_number ? 'passport' : 'tc';
                    if (this.formData.national_id === 'null') this.formData.national_id = '';

                }).catch(err => {
                    this.showErrors(err)
                })
        },
        handleSubmit() {
            if (this.originalStatus === 'pending_current_services' && this.checkPermission('turkmerapplication_workcertificateapprove')) {
                this.submitWorkCertificateApproval();
            } else {
                this.sendForm();
            }
        },
        async sendForm() {
            this.redirectTab()
            let personal_infoForm = await this.$refs.personal_infoForm.validate()
            let program_selectForm = await this.$refs.program_selectForm.validate()
            let documentsForm = await this.$refs.documentsForm.validate()

            if (personal_infoForm && program_selectForm && documentsForm) {
                const formData = new FormData();
                formData.append('address', this.formData.address);
                formData.append('birthdate', moment(this.formData.birthdate).format("YYYY-MM-DD"));
                formData.append('city_id', this.formData.city_id);
                formData.append('district_id', this.formData.district_id);
                formData.append('email', this.formData.email);
                formData.append('emergency_person', this.formData.emergency_person);
                formData.append('emergency_person_number', this.formData.emergency_person_number);
                formData.append('gender', this.formData.gender);
                formData.append('mobile_tel', this.formData.mobile_tel);
                formData.append('name', this.formData.name);
                formData.append('nationality_code', this.formData.nationality_code);
                formData.append('father_name', this.formData.father_name);
                formData.append('mother_name', this.formData.mother_name);
                formData.append('program_code', this.formData.program_code.value);
                formData.append('program_type', this.formData.program_type);
                formData.append('reason', this.formData.reason);
                formData.append('semester_id', this.formData.semester_id);
                formData.append('status', this.formData.status);
                formData.append('surname', this.formData.surname);
                formData.append('pin', this.formData.pin);

                if (this.identity_type === 'passport') {
                    formData.append('passport_number', this.formData.passport_number);
                } else {
                    formData.append('national_id', this.formData.national_id);
                }

                TurkmerApplicationService.update(this.$route.params.id, formData)
                    .then(response => {
                        if (response.data.success) {
                            this.$toast.success(this.$t('application_approval_process_successful'));
                            this.$router.push('/turkmer/application/list');
                        } else {
                            this.$toast.error(this.$t('error'));
                        }
                    }).catch(err => {
                    this.showErrors(err)
                })
            }
        },
        async getPrograms() {
            const config = {
                params: {
                    filter: {
                        faculty_code: "50",
                        department_code: "5002"
                    },
                    limit: -1
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            await programService.getAll(config)
                .then(response => {
                    this.programs = response.data.data

                }).catch(err => {
                    this.showError(err)
                })
        },
        async showDoc(doc, type) {
            const config = {
                params: {
                    type: type,
                    turkmer_application_id: this.$route.params.id,
                    file: doc,
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            };
            config.responseType = 'arraybuffer';

            TurkmerApplicationService.downloadAdminDocuments(config)
                .then(response => {
                    this._downloadFile(response, doc.filename)
                }).catch(err => {
                this.showErrors(err)
            })
        },
        async submitWorkCertificateApproval() {
            const valid = await this.$refs.workCertForm.validate();
            if (!valid) return;

            const data = {
                turkmer_application_id: this.$route.params.id,
                status: this.workCertForm.status,
            };

            if (this.workCertForm.status === 'accepted') {
                data.scholarship_type_code = this.workCertForm.scholarship_type_code;
                data.discount_rate = this.workCertForm.discount_rate;
            } else if (this.workCertForm.status === 'denied') {
                data.reason = this.workCertForm.reason;
            }

            await TurkmerApplicationService.workCertificateApprove(data)
                .then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$router.push('/turkmer/application/list');
                })
                .catch(e => this.$toast.error(this.$t('api.' + e.data.message)));
        },
        async adminUploadDoc(event, type) {
            const file = event.target.files[0];
            if (!file) return;

            const formData = new FormData();
            formData.append('turkmer_application_id', this.$route.params.id);
            formData.append('type', type);
            formData.append('file', file);

            await TurkmerApplicationService.adminUploadDocument(formData)
                .then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.getData(this.$route.params.id);
                })
                .catch(e => this.$toast.error(this.$t('api.' + e.data.message)));

            event.target.value = '';
        },
        async approveDoc(file, type, status) {
            const response = await this.$swal({
                text: status == 'accepted' ? this.$t('are_you_sure_to_approve') : status == 'denied' ? this.$t('are_you_sure_to_reject') : '',
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
            })
            if (response.isConfirmed !== true) {
                return
            }
            const data = {
                turkmer_application_id: this.$route.params.id,
                type,
                status
            }
            const res = await TurkmerApplicationService.approveDocument(data).catch((e) =>
                this.$toast.error(this.$t("api." + e.data.message))
            );

            if (res.data.success) {
                const updateDocument = {
                    ...this.formData.documents[type],
                    status
                };
                this.$set(this.formData.documents, type, updateDocument);
            }

            this.$toast.success(this.$t('api.' + res.data.message));
        },
        async next() {
            let isValid = false;

            if (this.tabIndex === 0) {
                isValid = await this.$refs.program_selectForm.validate();
            } else if (this.tabIndex === 1) {
                isValid = await this.$refs.personal_infoForm.validate();
            } else if (this.tabIndex === 2) {
                isValid = await this.$refs.documentsForm.validate();
            }

            if (isValid) {
                this.tabIndex++;
            }
        },
        back() {
            this.tabIndex--;
        },
        async uploadFiles(){
            let isVal = await this.$refs.documentsUploadForm.validate()
            if (isVal) {
                const formData = new FormData()
                formData.append('files[image]', this.fileData.image)
                formData.append('files[identity_front]', this.fileData.identity_front)
                formData.append('turkmer_application_id', this.formData.id)
                formData.append('pin', this.formData.pin)

                TurkmerApplicationService.uploadRequiredDocuments(formData).then(response => {
                    this.$toast.success(this.$t('api.'+response.data.message))
                    this.getData(this.$route.params.id)
                }).catch(e => {
                    this.showErrors(e, this.$refs.documentsUploadForm)
                })
            }
        }
    },
    computed: {
        filteredProgramCodeOptions() {
            if (!this.formData.program_type) {
                return [];
            }

            if (this.formData.program_type === 'exam') {
                return this.programs
                    .filter(itm => ['50020018', '50020019', '50020020'].includes(itm.code))
                    .map(itm => ({
                        text: this.getLocaleText(itm, 'name'),
                        value: itm.code
                    }));
            }

            if (this.formData.program_type === 'course') {
                return this.programs
                    .filter(itm => !['50020018', '50020019', '50020020'].includes(itm.code))
                    .map(itm => ({
                        text: this.getLocaleText(itm, 'name'),
                        value: itm.code
                    }));
            }
            return [];
        },
        certificateLabel() {
            const programCode = this.formData?.program_code?.value;

            return programCode == 50020005
                ? this.$t('have_language_proficiency_certificate')
                : this.$t('language_text');
        },
        workCertStatusOptions() {
            return [
                { value: null, text: this.$t('select'), disabled: true },
                { value: 'accepted', text: this.$t('approve') },
                { value: 'denied', text: this.$t('reject') },
            ];
        },
    },
}
</script>
